export default "__VITE_ASSET__3be3084f__"